import * as prismic from '@prismicio/client';

export const prismicClient = prismic.createClient('pitchtech');

export const isDocumentFilled = (
    arg?: prismic.ContentRelationshipField
): arg is prismic.FilledContentRelationshipField => {
    if (arg?.link_type === 'Document' && 'id' in arg) {
        return true;
    }
    return false;
};

export const isDocumentLinkFilled = (arg?: prismic.LinkField): arg is prismic.FilledContentRelationshipField => {
    if (arg?.link_type === 'Document' && 'id' in arg) {
        return true;
    }
    return false;
};

export const isMediaFilled = (arg?: prismic.LinkToMediaField): arg is prismic.FilledLinkToMediaField => {
    if (arg?.link_type === 'Media' && 'id' in arg) {
        return true;
    }
    return false;
};
